(function () {
  // ---- Cookie helpers ----
  function setCookie(name, value, days) {
    var expires = "";
    if (typeof days === "number") {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + d.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i].trim();
      if (c.indexOf(prefix) === 0) return decodeURIComponent(c.substring(prefix.length));
    }
    return null;
  }

  // ---- Config ----
  var COOKIE_NAME = "pdp_selected_size";   // change if you want
  var COOKIE_DAYS = 30;

  // Horizon-style picker: <input type="radio" name="Size-..." value="7" data-option-available="true">
  function isSizeRadio(el) {
    return !!(el &&
      el.matches &&
      el.matches('input[type="radio"][name^="Size-"]')
    );
  }

  function isAvailableSizeRadio(el) {
    // Prefer data-option-available when present (your markup has it)
    // Fall back to not-disabled.
    var attr = el.getAttribute("data-option-available");
    if (attr != null) return attr === "true";
    return !el.disabled && el.getAttribute("aria-disabled") !== "true";
  }

  // ---- 1) Store cookie when a visitor selects a size ----
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!isSizeRadio(t)) return;
    if (!t.checked) return;
    // Store the raw value (e.g. "7")
    setCookie(COOKIE_NAME, t.value, COOKIE_DAYS);
  }, true);

  // ---- 2) On page load, apply size from cookie ----
  function applySavedSize() {
    var saved = getCookie(COOKIE_NAME);
    if (!saved) return;

    // Find a matching size option on THIS product
    var selector = 'input[type="radio"][name^="Size-"][value="' + CSS.escape(saved) + '"]';
    var candidate = document.querySelector(selector);
    if (!candidate) return;
    if (!isAvailableSizeRadio(candidate)) return;

    // If already selected, do nothing
    if (candidate.checked) return;

    // Prefer click() so the theme’s variant logic runs exactly as if user clicked
    candidate.click();

    // Safety: some themes rely on change/input; fire them too
    candidate.dispatchEvent(new Event("input", { bubbles: true }));
    candidate.dispatchEvent(new Event("change", { bubbles: true }));
  }
  window.applySavedSize = applySavedSize;

  // Run after DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applySavedSize);
  } else {
    applySavedSize();
  }
})();
